import {
  NotificationSkeleton,
  SkeletonWrapper,
} from 'modules/notificationCenter/components/NotificationSkeleton';

export const NotificationsLoading = () => {
  return (
    <SkeletonWrapper>
      {['a', 'b', 'c', 'd', 'e', 'f'].map((val) => (
        <NotificationSkeleton key={`skeleton-${val}`} />
      ))}
    </SkeletonWrapper>
  );
};
